<template>
  <div class="card shadow-md p-2 sm:p-4 lg:p-6">
    <!-- Header Section -->
    <div class="mb-4 sm:mb-6">
      <h1 class="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-800 dark:text-white">
        Division Dashboard
      </h1>
    </div>

    <!-- Statistics Cards - First Row (5 cards) -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-6 mb-4 sm:mb-6">
      <!-- School Count Card -->
      <div @click="showDialog = true, teacherCall = true" class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              School Count
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              {{ schoolCount }}
            </div>
          </div>
          <div class="flex items-center justify-center bg-yellow-100 dark:bg-yellow-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-building text-yellow-500 text-lg sm:text-xl"></i>
          </div>
        </div>

         <span v-if="studentDif < 0" class="text-red-600 font-medium text-xs sm:text-sm"> {{ schoolDif || 0 }}</span>

        <span v-else class="text-green-600 font-medium text-xs sm:text-sm">+ {{ schoolDif || 0 }}</span>

      </div>

      <!-- Teacher Count Card -->
      <div @click="showDialog2 = true, teacherCall = true, nonteacherCall = false" class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Teacher Count
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              {{ teacherCount }}
            </div>
          </div>
          <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-users text-blue-500 text-lg sm:text-xl"></i>
          </div>
        </div>

         <span v-if="studentDif < 0" class="text-red-600 font-medium text-xs sm:text-sm"> {{ teacherDif || 0 }}</span>

        <span v-else class="text-green-600 font-medium text-xs sm:text-sm">+ {{ teacherDif || 0 }}</span>

      </div>

      <!-- Non Teaching Count Card -->
      <div @click="showDialog2 = true,  nonteacherCall = true, teacherCall = false" class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Non Teaching Count
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              {{ nonTeaching }}
            </div>
          </div>
          <div class="flex items-center justify-center bg-indigo-100 dark:bg-indigo-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-user-edit text-indigo-500 text-lg sm:text-xl"></i>
          </div>
        </div>
         <span v-if="studentDif < 0" class="text-red-600 font-medium text-xs sm:text-sm"> {{ nonTeachingDif || 0 }}</span>

        <span v-else class="text-green-600 font-medium text-xs sm:text-sm">+ {{ nonTeachingDif || 0 }}</span>

      </div>

      <!-- Student Count Card -->
      <div @click="showDialog1 = true" class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Student Count
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              {{ studentCount }}
            </div>
          </div>
          <div class="flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-users text-green-500 text-lg sm:text-xl"></i>
          </div>
        </div>
        <span v-if="studentDif < 0" class="text-red-600 font-medium text-xs sm:text-sm"> {{ studentDif || 0 }}</span>

        <span v-else class="text-green-600 font-medium text-xs sm:text-sm">+ {{ studentDif || 0 }}</span>
      </div>

      <!-- Dropout Rate Card -->
      <div class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Dropout Rate
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              10.7%
            </div>
          </div>
          <div class="flex items-center justify-center bg-red-100 dark:bg-red-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-user-minus text-red-500 text-lg sm:text-xl"></i>
          </div>
        </div>
        <span class="text-red-600 font-medium text-xs sm:text-sm">+ 2.1%</span>
      </div>
    </div>

    <!-- Statistics Cards - Second Row (4 cards) -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 mb-6 sm:mb-8">
      <!-- Average GPA Card -->
      <div class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Average GPA
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              89%
            </div>
          </div>
          <div class="flex items-center justify-center bg-indigo-100 dark:bg-indigo-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-chart-pie text-indigo-500 text-lg sm:text-xl"></i>
          </div>
        </div>
        <span class="text-green-600 font-medium text-xs sm:text-sm">+ 3%</span>
      </div>

      <!-- Attendance Rate Card -->
      <div class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Attendance Rate
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              94.2%
            </div>
          </div>
          <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-list-check text-purple-500 text-lg sm:text-xl"></i>
          </div>
        </div>
        <span class="text-red-600 font-medium text-xs sm:text-sm">- 1.3%</span>
      </div>

      <!-- Graduation Rate Card -->
      <div class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Graduation Rate
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              98.7%
            </div>
          </div>
          <div class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-graduation-cap text-cyan-500 text-lg sm:text-xl"></i>
          </div>
        </div>
        <span class="text-green-600 font-medium text-xs sm:text-sm">+ 2.1%</span>
      </div>

      <!-- Parent Engagement Card -->
      <div class="bg-white cursor-pointer transition-transform hover:scale-[1.02] dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
        <div class="flex justify-between items-start mb-3 sm:mb-4">
          <div class="flex-1 min-w-0">
            <span class="block text-gray-500 dark:text-gray-400 font-medium mb-2 text-xs sm:text-sm">
              Parent Engagement
            </span>
            <div class="text-gray-900 dark:text-white font-bold text-xl sm:text-2xl lg:text-3xl">
              {{ parentEngagement }}%
            </div>
          </div>
          <div class="flex items-center justify-center bg-amber-100 dark:bg-amber-400/10 rounded-lg flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12">
            <i class="pi pi-users text-amber-500 text-lg sm:text-xl"></i>
          </div>
        </div>
        <span class="text-green-600 font-medium text-xs sm:text-sm">+ 5%</span>
      </div>
    </div>

    <!-- Charts and Events Section -->
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-4 sm:gap-6">
      <!-- Charts Section -->
      <div class="xl:col-span-8 space-y-4 sm:space-y-6">
        <!-- Year-Over-Year Enrollment Chart -->
        <div class="bg-white dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
          <div class="font-semibold text-lg sm:text-xl mb-4">Year-Over-Year Enrollment Data</div>
          <div class="h-64 sm:h-80 lg:h-96">
            <Chart
              type="line"
              :data="lineData"
              :options="lineOptions"
              class="h-full w-full"
            />
          </div>
        </div>

        <!-- Academic Performance by Subject Chart -->
        <div class="bg-white  dark:bg-gray-800 shadow-md rounded-lg p-4 sm:p-5 lg:p-6">
          <div class="font-semibold text-lg sm:text-xl mb-4">Academic Performance by Subject</div>
          <div class="h-64 sm:h-80 lg:h-96">
            <Chart
              type="bar"
              :data="barData"
              :options="barOptions"
              class="h-full w-full"
            />
          </div>
        </div>

        <!-- Attendance Breakdown Chart -->
        <div class="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 sm:p-8 lg:p-10 xl:p-12">
          <div class="font-semibold text-xl sm:text-2xl lg:text-3xl mb-6 text-center">Attendance Breakdown</div>
          <div class="h-64 sm:h-80 md:h-96 lg:h-[28rem] xl:h-[32rem] flex items-center justify-center">
            <Chart
              type="doughnut"
              :data="pieData"
              :options="pieOptions"
              class="w-full h-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-xl"
            />
          </div>
        </div>
      </div>

      <!-- Events Section -->
      <div class="xl:col-span-4">
        <EventsComponents :eventlimit="7" class="h-full" />
      </div>
    </div>

    <Dialog
      v-model:visible="showDialog"
      modal
      :style="{ width: '90vw', position: 'absolute', top: '5vh' }"
      position="top"
    >
      <SchoolView />
    </Dialog>

    <Dialog
      v-model:visible="showDialog1"
      modal
      :style="{ width: '70vw', position: 'absolute', top: '5vh' }"
      position="top"
    >
      <StudentView />
    </Dialog>

    <Dialog
      v-model:visible="showDialog2"
      modal
      :style="{ width: '90vw', position: 'absolute', top: '5vh' }"
      position="top"
    >
      <StaffView :dbCall="true" :teacherCall="teacherCall" :nonteacherCall="nonteacherCall" />
    </Dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, watchEffect, computed, onBeforeMount } from 'vue'
import * as XLSX from 'xlsx'
import { useEventStore } from '@/store/admin/EventStore'
import { storeToRefs } from 'pinia'
import EventsComponents from '@/components/EventsComponents.vue'
import { useDbCountStore } from '@/store/admin/DashboardCountStore'
import SchoolView from './SchoolView.vue'
import StudentView from '@/views/admin/StudentView.vue'

import { useAuthStore } from '@/auth/auth'
import StaffView from './StaffView.vue'

const eventStore = useEventStore()
const authStore = useAuthStore()
const dbStore = useDbCountStore()
const {studentCount, eventsCount, teacherCount, schoolCount, parentEngagement, nonTeaching,  studentDif,teacherDif,schoolDif,nonTeachingDif} = storeToRefs(dbStore)
const { eventx } = storeToRefs(eventStore)
eventStore.getEventPID(authStore.school_id)

const showDialog = ref(false)
const showDialog1 = ref(false)
const showDialog2 = ref(false)
const nonteacherCall = ref(false)
const teacherCall = ref(false)

// Transform raw event data into display format
const events = computed(() => {
  const eventData = eventx.value?.data || eventx.value;

  if (!eventData || !Array.isArray(eventData)) {
    console.log("No valid event data found");
    return [];
  }

  const transformedEvents = eventData.map(event => {
    const dateRange = formatDateRange(event.event_from_date, event.event_to_date);
    return {
      pid: event.pid,
      dateInfo: dateRange,
      title: event.name,
      description: event.description,
      time: formatEventTime(event.event_from_time, event.event_to_time),
      location: event.school?.name || 'System-wide Event',
      type: event.event_type.description,
      severity: getSeverity(event.event_type.type)
    };
  });

  return transformedEvents.slice(0, 5);
});

// Helper function to format date ranges
function formatDateRange(fromDateStr, toDateStr) {
  const from = new Date(fromDateStr);
  const to = new Date(toDateStr);

  const sameDay = from.getDate() === to.getDate() &&
                  from.getMonth() === to.getMonth() &&
                  from.getFullYear() === to.getFullYear();

  const sameMonthYear = from.getMonth() === to.getMonth() &&
                        from.getFullYear() === to.getFullYear();

  if (sameDay) {
    return {
      displayType: 'single',
      month: from.toLocaleString('en-US', { month: 'short' }),
      day: from.getDate(),
      dateDisplay: from.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    };
  }

  if (sameMonthYear) {
    return {
      displayType: 'multi-same-month',
      month: from.toLocaleString('en-US', { month: 'short' }),
      fromDay: from.getDate(),
      toDay: to.getDate(),
      dateDisplay: `${from.getDate()} - ${to.getDate()} ${from.toLocaleString('en-US', { month: 'short' })}`
    };
  }

  return {
    displayType: 'multi-diff-month',
    fromMonth: from.toLocaleString('en-US', { month: 'short' }),
    fromDay: from.getDate(),
    toMonth: to.toLocaleString('en-US', { month: 'short' }),
    toDay: to.getDate(),
    dateDisplay: `${from.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${to.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`
  };
}

function formatEventTime(startTime, endTime) {
  const formatTime = (timeStr) => {
    const [hours, minutes] = timeStr.split(':');
    const hour = parseInt(hours, 10);
    const minute = parseInt(minutes, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes.padStart(2, '0')} ${period}`;
  };

  return `${formatTime(startTime)} - ${formatTime(endTime)}`;
}

function getSeverity(eventType) {
  const typeMap = {
    'regular_holiday': 'success',
    'special_working_holiday': 'warning',
    'special_non_working_holiday': 'danger',
  };
  return typeMap[eventType] || 'info';
}

watchEffect(() => {
  if (eventx.value) {
    // console.log("Raw eventx data:", eventx.value);
  }

  if (events.value) {
    // console.log("Transformed events data:", events.value);
  } else {
    // console.log("Events data is not available yet");
  }
});

const barData = ref(null)
const barOptions = ref(null)
const pieData = ref(null)
const pieOptions = ref(null)
const lineData = ref(null)
const lineOptions = ref(null)

onBeforeMount( async ()  => {
  await dbStore.getStudentCount(authStore.user_pid,"")
  await dbStore.getTeacherCount(authStore.user_pid,"")
  await dbStore.getSchoolCount(authStore.user_pid,"")
  await dbStore.getParentEngagement(authStore.user_pid,"")
  await dbStore.getNonTeachingCount(authStore.user_pid,"")
})

onMounted(() => {
  setColorOptions()
  setcolor()
})

const clickarr = () => {
  alert('asd')
}

function setColorOptions() {
  const documentStyle = getComputedStyle(document.documentElement)
  const textColor = documentStyle.getPropertyValue('--text-color')
  const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary')
  const surfaceBorder = documentStyle.getPropertyValue('--surface-border')

  barData.value = {
    labels: ['Math', 'Science', 'English', 'History', 'Arts', 'Music', 'Filipino'],
    datasets: [
      {
        label: 'Elementary',
        backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
        borderColor: documentStyle.getPropertyValue('--p-primary-500'),
        data: [88, 89, 80, 81, 96, 95, 98],
      },
      {
        label: 'High School',
        backgroundColor: documentStyle.getPropertyValue('--docsearch-primary-color'),
        borderColor: documentStyle.getPropertyValue('--docsearch-primary-color'),
        data: [80, 78, 86, 90, 93, 97, 90],
      },
    ],
  }

  barOptions.value = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          fontColor: textColor,
          usePointStyle: true,
          padding: 20
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: textColorSecondary,
          font: {
            weight: 500,
            size: window.innerWidth < 640 ? 10 : 12
          },
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        ticks: {
          color: textColorSecondary,
          font: {
            size: window.innerWidth < 640 ? 10 : 12
          }
        },
        grid: {
          color: surfaceBorder,
          drawBorder: false,
        },
      },
    },
  }

  pieData.value = {
    labels: ['83% Present', '7% Absent', '10% Late'],
    datasets: [
      {
        data: [83, 7, 10],
        backgroundColor: [
          documentStyle.getPropertyValue('--p-indigo-500'),
          documentStyle.getPropertyValue('--p-purple-500'),
          documentStyle.getPropertyValue('--p-teal-500'),
        ],
        hoverBackgroundColor: [
          documentStyle.getPropertyValue('--p-indigo-400'),
          documentStyle.getPropertyValue('--p-purple-400'),
          documentStyle.getPropertyValue('--p-teal-400'),
        ],
      },
    ],
  }

  pieOptions.value = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          color: textColor,
          padding: 20,
          font: {
            size: window.innerWidth < 640 ? 11 : 13
          }
        },
      },
    },
  }
}

function setcolor() {
  const documentStyle = getComputedStyle(document.documentElement)
  const textColor = documentStyle.getPropertyValue('--text-color')
  const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary')
  const surfaceBorder = documentStyle.getPropertyValue('--surface-border')

  lineData.value = {
    labels: ['2019', '2020', '2021', '2022', '2023', '2024', '2025'],
    datasets: [
      {
        label: 'Elementary',
        data: [50400, 55000, 60000, 65000, 70000, 72232, 75000],
        fill: false,
        backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
        borderColor: documentStyle.getPropertyValue('--p-primary-500'),
        tension: 0.4,
      },
      {
        label: 'High School',
        data: [53324, 56544, 59633, 62589, 65978, 68545, 71533],
        fill: false,
        backgroundColor: documentStyle.getPropertyValue('--docsearch-primary-color'),
        borderColor: documentStyle.getPropertyValue('--docsearch-primary-color'),
        tension: 0.4,
      },
    ],
  }

  lineOptions.value = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          fontColor: textColor,
          usePointStyle: true,
          padding: 20
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: textColorSecondary,
          font: {
            size: window.innerWidth < 640 ? 10 : 12
          }
        },
        grid: {
          color: surfaceBorder,
          drawBorder: false,
        },
      },
      y: {
        ticks: {
          color: textColorSecondary,
          font: {
            size: window.innerWidth < 640 ? 10 : 12
          }
        },
        grid: {
          color: surfaceBorder,
          drawBorder: false,
        },
      },
    },
  }
}

const schoolslist = ref([
  { name: 'All School', code: 'allschool' },
  { name: 'Sa Fernando', code: 'sanfernando' },
  { name: 'Mexico', code: 'mexico' },
])

const gradeslist = ref([
  { name: 'All Grades', code: 'allgrade' },
  { name: 'Grade 1', code: 'g1' },
  { name: 'Grade 2', code: 'g2' },
  { name: 'Grade 3', code: 'g3' },
  { name: 'Grade 4', code: 'g4' },
  { name: 'Grade 5', code: 'g5' },
  { name: 'Grade 6', code: 'g6' },
])

const schoolvalue = ref(null)
const gradevalue = ref(null)

const exportToExcel = () => {
  const workbook = XLSX.utils.book_new()

  const worksheetData = [
    ['Dataset', 'Math', 'Science', 'English', 'History', 'Arts', 'Music', 'Filipino'],
    ['Elementary', 88, 89, 80, 81, 96, 95, 98],
    ['High School', 80, 78, 86, 90, 93, 97, 90],
  ]

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

  const headerStyle = {
    font: { bold: true },
    fill: { fgColor: { rgb: 'CCCCCC' } },
  }

  for (let col = 0; col < worksheetData[0].length; col++) {
    const cellAddress = XLSX.utils.encode_cell({ c: col, r: 0 })
    if (!worksheet[cellAddress]) worksheet[cellAddress] = {}
    worksheet[cellAddress].s = headerStyle
  }

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Subject Grades')
  XLSX.writeFile(workbook, 'division_performance_report.xlsx')
}
</script>

<style scoped>
/* Additional responsive styles if needed */
@media (max-width: 640px) {
  .pi {
    font-size: 1rem !important;
  }
}

/* Custom styles for better mobile experience */
.space-y-4 > * + * {
  margin-top: 1rem;
}

@media (min-width: 640px) {
  .space-y-6 > * + * {
    margin-top: 1.5rem;
  }
}
</style>
